import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationInputStyle, applyMaxLengths } from "../../constants";
import ApplyRequiredError from "./ApplyRequiredError";
import { updateAppData } from "../../utils/actionUtils";
import { Box } from "@mui/material";
import FettiInput from "../FettiInput";
import SimpleApplyField from "./SimpleApplyField";
import ApplyLocationAutocomplete from "./ApplyLocationAutocomplete";
import { valueToPhoneNumber } from "../../utils/utils";

const BasicApply = () => {
  const dispatch = useDispatch();
  const appData = useSelector((state) => state.apply.app);
  return (
    <>
      <Box sx={ApplicationInputStyle.categoryLabel}>Basic Info</Box>
      <SimpleApplyField
        label="First name*"
        field="firstName"
        missingMsg="First name is required"
        placeholder="First name"
      />
      <SimpleApplyField
        label="Last name*"
        field="lastName"
        missingMsg="Last name is required"
        placeholder="Last name"
      />
      <SimpleApplyField
        label="Email*"
        field="email"
        missingMsg="Email is required"
        placeholder="Email"
      />
      <ApplyLocationAutocomplete />
      <SimpleApplyField
        label="Phone Number"
        field="phone"
        placeholder="Phone Number"
        valueFunc={valueToPhoneNumber}
        optional
      />
    </>
  );
};

export default BasicApply;
